<template>
  <div v-if="!loading" class="sp-mode">
    <sp-site-header/>
    <article>
      <div class="message-container">
        <div class="message">
          指定されたページは存在しません。<br/>
          恐れ入りますが、<br/>
          <router-link :to="{ name: 'SpSiteTop' }">トップページ</router-link>からお探しください。
        </div>
      </div>
    </article>
    <sp-site-footer/>
  </div>
</template>

<script>
import SpSiteHeader from '@/components/sp/SpSiteHeader'
import SpSiteFooter from '@/components/sp/SpSiteFooter'
import { mapState } from 'vuex'
export default {
  name: 'SpSiteTop',
  components: {
    SpSiteHeader,
    SpSiteFooter
  },
  created () {
    this.$store.commit('loading/setStatus', false)
  },
  computed: {
    ...mapState('loading', {
      loading: state => state.status
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/variables';
.message a {
    text-decoration: underline;
}
.message-container {
  display: table;
  width: 100%;
  .message {
    height: 300px;
    font-weight: 600;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/SpPageNotFound.vue